import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const SEND_VERIFICATION_EMAIL_MUTATION = gql`
  mutation SendVerificationEmailMutation {
    sendVerificationEmail {
      sent
      errorCode
    }
  }
`;

export default function useSendVerificationEmail() {
  const [sendVerificationEmailMutation, { loading, error }] = useMutation(SEND_VERIFICATION_EMAIL_MUTATION, {
    noThrow: true,
  });

  const sendVerificationEmail = useCallback(async () => {
    const response = await sendVerificationEmailMutation();
    return response?.data?.sendVerificationEmail || null;
  }, [sendVerificationEmailMutation]);

  useError(error);

  return {
    sendVerificationEmail,
    loading,
  };
}
